import React, { useEffect } from "react";

import Header from "../Header/Header";
import "./HomeWeb.css";
import "../../../assets/website/vendor/bootstrap-icons/bootstrap-icons.css";
import "../../../assets/website/vendor/swiper/swiper-bundle.min.css";
import "../../../assets/website/vendor/aos/aos.css";
import "../../../assets/website/vendor/glightbox/css/glightbox.min.css";

import "../../../assets/website/css/main.css";
import Main from "../Main/Main";
import Hero from "../Hero/Hero";
import Footer from "../Footer/Footer";
import About from "../About/About";
import { useTranslation } from "react-i18next";

function HomeWeb() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("home"); // ✅ Correct
  }, [t]); // ✅ Add 't' as a dependency to update the title when the language changes

  return (
    <>
      <Header />
      <Main>
        <Hero />
        <About />
      </Main>
      <Footer />
      {/* <BackToTop /> */}
    </>
  );
}

export default HomeWeb;
